<template lang="pug">
ul.nav.nav-md(role="tablist")
    li.m-b-sm(v-for="(tabName, tabKey) in tabs", v-if="isTabEnabled(tabKey)")
        a.nav-link(
            @click="setTab(tabKey)",
            :class="{ active: isActive(tabKey) }",
            :style="{'cursor': pointerStyle}"
        ) {{ tabName }}
</template>

<script>
export default {
    props: {
        currentTab: {
            required: true,
            type: String,
        },
    },

    computed: {
        tabs() {
            return {
                'outlet-target': `${this.trans('general.outlet')} Target`,
                'central-settings': `${this.trans('general.central')} Settings`,
            };
        },

        pointerStyle() {
            if (this.onLoading('load settings')) {
                return 'wait';
            } else {
                return 'pointer';
            }
        },
    },

    methods: {
        setTab(tab) {
            this.$emit('tab-changed', tab);
        },

        isTabEnabled(tab) {
            return true;
        },

        isActive(tabKey) {
            return this.currentTab == tabKey;
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/setting/setting-tabs.vue